export default __webpack_public_path__ + "static/media/pokemon_poison.b906475c.png";